// extracted by mini-css-extract-plugin
export var button = "pagination-module--button--bff12";
export var container = "pagination-module--container--457de";
export var number = "pagination-module--number--68c0b";
export var numbers = "pagination-module--numbers--2a98e";